/* global axios */
import ApiClient from '../ApiClient';

class EvolutionInstance extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution_instance`);
  }
}

export default new EvolutionInstance();
